import { useMutation } from 'react-query';

import { runSchedulingSimulation as mutationFn } from 'api/endPoints/runSchedulingSimulation';

export const useMutationRunCpmSimulation = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    metaDataId: number;
    simulationDate: number;
}
